export default __webpack_public_path__ + "static/media/call-end-white-icon.e37ba5b7.svg";